import * as React from 'react';
import classNames from 'classnames';
import {RichIcon, RichIconType, RichIconProps} from '../Icon';
import style from './tag.scss';

type SpanElementProps = JSX.IntrinsicElements['span'];
type AnchorElementProps = JSX.IntrinsicElements['a'];
type ComposedProps = SpanElementProps & AnchorElementProps;

export interface TagProps extends ComposedProps {
  tag: string;
  link?: string;
  newTab?: boolean;
  icon?: RichIconType;
  iconProps?: RichIconProps;
  isPlaceholder?: boolean;
}

export class Tag extends React.Component<TagProps> {
  handleClick = (event) => {
    const {onClick, link} = this.props;

    if (onClick || link) {
      event.stopPropagation();
    }

    if (onClick) {
      onClick(event);
    }
  };

  render() {
    const {
      tag = '',
      link = '',
      icon,
      iconProps = {},
      className = '',
      isPlaceholder,
      onClick,
      newTab,
      ...restProps
    } = this.props;

    const componentProps = {
      className: classNames(className, style.tag, {
        [style.link]: Boolean(link),
        [style.placeholder]: isPlaceholder,
      }),
      onClick: this.handleClick,
      ...restProps,
    };

    if (link) {
      componentProps.href = link;
    }
    const Component = link ? 'a' : 'span';

    return (
      <Component {...componentProps}>
        {icon ? <RichIcon icon={icon} {...iconProps} /> : null}
        {tag}
      </Component>
    );
  }
}
